<script lang="ts" setup>
	import type { Dayjs } from 'dayjs'

	const props = defineProps<{
		date?: Dayjs | Date
		wrapperClass?: string
	}>()
	const second = 1000
	const minute = second * 60
	const hour = minute * 60
	const day = hour * 24

	const countSystem = reactive({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0
	})

	const countDown = computed(() => {
		return new Date(props.date as Date).getTime()
	})
	const startCountDown = () => {
		const interval = setInterval(function () {
			const now = new Date().getTime()
			const distance = countDown.value - now
			countSystem.days = Math.floor(distance / day)
			countSystem.hours = Math.floor((distance % day) / hour)
			countSystem.minutes = Math.floor((distance % hour) / minute)
			countSystem.seconds = Math.floor((distance % minute) / second)
			if (distance <= 0) {
				clearInterval(interval)
			}
		})
	}
	onMounted(() => {
		if (props.date) {
			startCountDown()
		}
	})
</script>

<template>
	<div>
		<div
			class="inline-flex min-h-[64px] items-center justify-center gap-x-4 rounded-lg p-[16px_32px] text-xl font-semibold text-white sm:text-3xl"
			:class="wrapperClass"
		>
			<template v-if="countSystem.days > 0">
				<span>{{ String(countSystem.days).padStart(2, '0') }}</span>
				<span>Day{{ countSystem.days > 1 ? 's' : '' }}</span>
			</template>
			<template v-else>
				<span>{{ String(countSystem.hours).padStart(2, '0') }}</span>
				<span>:</span>
				<span>{{ String(countSystem.minutes).padStart(2, '0') }}</span>
				<span>:</span>
				<span>{{ String(countSystem.seconds).padStart(2, '0') }}</span>
			</template>
		</div>
	</div>
</template>
